import { useEffect, useState } from "react"
import { TextInput } from "./textInput"

export const SearchInput = ({ value, onSearch }: { value: string, onSearch: (query: string) => void }) => {
  const [inputValue, setInputValue] = useState<string>(value)
  const [debounceValue, setDebaounceValue] = useState<string>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebaounceValue(inputValue)
    }, 500)
    return () => clearTimeout(handler)
  }, [inputValue])

  useEffect(() => {
    if (debounceValue !== value)
      onSearch(debounceValue)

  }, [debounceValue])

  return (
    <div style={{ display: "inline-block", width: "200px", marginTop: "-16px", marginBottom: "-8px" }}>

      <TextInput
        value={inputValue}
        title="Search..."
        onChange={(e) => setInputValue(e ?? '')}
      />
    </div>
  )
}